export default "__VITE_ASSET__889523f0__"